let scrollPos = 0,
	headerHeight = document.querySelector('.jsSiteHeader').clientHeight,
	scrollTimeout;

// adding scroll event
document.defaultView.addEventListener('scroll', () => {
	handleScroll();
});

function goingUp() {
	document.body.classList.add('going-up');
	document.body.classList.remove('going-down');
}
function goingDown() {
	document.body.classList.add('going-down');
	document.body.classList.remove('going-up');
}

function handleScroll() {
	// Note if scrolling starts
	document.body.classList.add('is-scrolling');

	// Clear any existing timeout to ensure we don't remove the class prematurely
	clearTimeout(scrollTimeout);

	// Set a timeout to remove the 'is-scrolling' class after scrolling has stopped
	scrollTimeout = setTimeout(() => {
		document.body.classList.remove('is-scrolling');
	}, 100);

	// If we're in iOS's "let's bounce the document to show we're at the top, and let's make it count as a scroll position" state, just stay in the "Going up so show everything" mode.
	if ( scrollPos > -headerHeight)
	{
		goingUp();
		document.body.classList.add('at-top');
	}
	// detects new state and compares it with the new one
	else
	{
		document.body.classList.remove('at-top');
		if ( (document.body.getBoundingClientRect()).top > scrollPos )
		{
			goingUp();
		}
		else
		{
			goingDown();
		}
	}
	// saves the new position for iteration.
	scrollPos = (document.body.getBoundingClientRect()).top;
}

// If any "clickables" in the header receive focus, ensure the header is visible

// Get all clickable elements in the header
const headerLinks = document.querySelectorAll('.site__header a, .site__header button, .site__header input');

// Add event listener for focus
headerLinks.forEach((link) => {
	link.addEventListener('focus', () => {
		goingUp();
	});
});

handleScroll();